export const formFieldHiddenBehaviour = Object.freeze({
	AlwaysOverwrite: 1,
	OverWriteIfEmpty: 2,
	OverwriteWhenRequired: 3,
});
